<template>
    <div>
      <div class="row settings-tabs full-height-tabs">
        <div class="col-lg-12 col-md-12">
          <vue-tabs
            ref="tabs"
            direction="vertical"
            class="row dispatch-tabs full-height-tabs items-align-dispatch-tabs text-align-dispatch-tabs"
            value="Description"
            @tab-change="handleTabChange"
          >
            <v-tab :title="$t('pages.products')" class="text-left">
              <products-list v-if="isProducts" :isProducts="isProducts"></products-list>
            </v-tab>
            <v-tab v-if="canAccessPriceLists()" :title="$t('pages.isPriceList')" class="text-left">
              <price-profile v-if="isPriceList" :isPriceList="isPriceList"></price-profile>
            </v-tab>
            <v-tab :title="$t('pages.stock')" class="text-left">
              <stock v-if="isStock" :isStock="isStock"></stock>
            </v-tab>
            <v-tab :title="$t('pages.categories')" class="text-left">
              <categories v-if="isCategories" :isCategories="isCategories"></categories>
            </v-tab>
            <v-tab :title="$t('pages.topCategory')" class="text-left">
              <top-categories v-if="isTopCategories" :isTopCategories="isTopCategories"></top-categories>
            </v-tab>
            <v-tab :title="$t('pages.productOptions')" class="text-left">
              <product-options v-if="isProductOptions" :isProductOptions="isProductOptions"></product-options>
            </v-tab>
            <v-tab :title="$t('pages.groupOptions')" class="text-left">
              <group-options v-if="isGroupOptions" :isGroupOptions="isGroupOptions"></group-options>
            </v-tab>
            <v-tab :title="$t('pages.productFilters')" class="text-left">
              <product-filters v-if="isProductFilters" :isProductFilters="isProductFilters"></product-filters>
            </v-tab>
            <v-tab :title="$t('pages.menuLinks')" class="text-left">
              <menu-links v-if="isMenuLinks" :isMenuLinks="isMenuLinks"></menu-links>
            </v-tab>
          </vue-tabs>
        </div>
      </div>
    </div>
</template>

  <script>
  import ProductsList from 'src/components/Dashboard/Views/Products/ProductsList.vue'
  import PriceProfile from 'src/components/Dashboard/Views/Products/PriceProfile.vue'
  import Stock from 'src/components/Dashboard/Views/Products/Stock.vue'
  import Categories from 'src/components/Dashboard/Views/Categories/Categories.vue'
  import TopCategories from 'src/components/Dashboard/Views/TopCategories/TopCategories.vue'
  import ProductOptions from 'src/components/Dashboard/Views/ProductOptions/ProductOptions.vue'
  import GroupOptions from 'src/components/Dashboard/Views/GroupOptions/GroupOptions.vue'
  import ProductFilters from 'src/components/Dashboard/Views/Settings/Tabs/ProductFilters.vue'
  import MenuLinks from 'src/components/Dashboard/Views/MenuLinks/MenuLinks.vue'

  export default {
    components: {
      ProductsList,
      PriceProfile,
      Stock,
      Categories,
      TopCategories,
      ProductOptions,
      GroupOptions,
      ProductFilters,
      MenuLinks
    },
    data () {
      return {
        isProducts: false,
        isPriceList: false,
        isStock: false,
        isCategories: false,
        isTopCategories: false,
        isProductOptions: false,
        isGroupOptions: false,
        isProductFilters: false,
        isMenuLinks: false
      }
    },
    mounted () {
      this.switchTab()
    },
    methods: {
      resetStates () {
        this.isProducts = false
        this.isPriceList = false
        this.isStock = false
        this.isCategories = false
        this.isTopCategories = false
        this.isProductOptions = false
        this.isGroupOptions = false
        this.isProductFilters = false
        this.isMenuLinks = false
      },
      switchTab () {
        const index = this.$route.query.tabIndex
        this.$nextTick(() => {
          if (index && this.$refs.tabs) {
            this.$refs.tabs.navigateToTab(parseInt(index))
          }
        })
      },
      handleTabChange (tabIndex, newTab, oldTab) {
        this.resetStates()
        this.$router.push(`${this.$route.path}?tabIndex=${tabIndex}`)
        switch (newTab.title) {
          case this.$t('pages.products'):
            this.isProducts = true
            break
          case this.$t('pages.isPriceList'):
            this.isPriceList = true
            break
          case this.$t('pages.stock'):
            this.isStock = true
            break
          case this.$t('pages.categories'):
            this.isCategories = true
            break
          case this.$t('pages.topCategory'):
            this.isTopCategories = true
            break
          case this.$t('pages.productOptions'):
            this.isProductOptions = true
            break
          case this.$t('pages.groupOptions'):
            this.isGroupOptions = true
            break
          case this.$t('pages.productFilters'):
            this.isProductFilters = true
            break
          case this.$t('pages.menuLinks'):
            this.isMenuLinks = true
            break
          default:
            this.isFirst = true
            break
        }
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Catalog/CatalogSidebar.vue